import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import RightIngredientsList from "./ingredient";
import WeNeverUse from "./neveruse";
import { GalleryImage } from "../gallery/galleryDetails";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Card from "react-bootstrap/Card";
import CustomButton from "../component/button/button";
import { Helmet } from "react-helmet-async";

const Home = () => {

  const [ uniqueProducts, setUniqueProducts ] = useState([]);

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };
  
  const UniqueProducts = () => {

    const uniqueCategoryProducts = [];
    const seenCategories = new Set();

    GalleryImage.forEach(product => {
      if (!seenCategories.has(product.Category)) {
        seenCategories.add(product.Category);
        uniqueCategoryProducts.push(product);
      }
    });
    console.log(uniqueCategoryProducts);
    setUniqueProducts(uniqueCategoryProducts);

  }

  useEffect(() => {
    UniqueProducts();
  }, [])

  const handleClick = (paths) => {
    window.open(`https://order.wheatbakes.com/onlineorder/`, "_blank");
  };

  const handleClickButton = (paths) => {
    window.location.href = paths;
  };

  return (
    <>
    <Helmet>
        <title>Natural Cakes in Chennai | Healthy & Eggless Cakes – WheatBakes</title>
        <meta
          name="description"
          content="Enjoy natural, eggless, no-maida cakes made with whole wheat, millet & no preservatives. Fresh healthy cakes delivered in Chennai."
        />
        <link rel="canonical" href="https://wheatbakes.com/home" />
      </Helmet>
    
    <div>
    <div>
        <img src={"images/carosel/lap_banner.png"} alt="HomeBanner" className="home-banner-img d-none d-md-block" />
        <img src={"images/carosel/mobile_banner.png"} alt="HomeBanner" className="home-banner-img d-block d-md-none" />
      </div>

      <div className="bg-text-image-card">
        <div className="container py-5" data-aos="fade-up">
          <div className="standards">
            <div className="heading text-center">
              <p className="text-uppercase m-0">BEYOND THE BITE</p>

              <h1 className="mb-4">Our Specialities</h1>
            </div>
          </div>

          <Carousel responsive={responsive} infinite={true} autoPlay={false} className="home-carosel">
            {uniqueProducts.map((product, index) => (
              <div
              key={product.id}
              className="p-2"
            >
              <Card className="gallery-card w-100">
                <div className="gallery-card-imgwrap" role="button">
                  <img src={product.imgSrc} alt={product.name} />
                </div>

                <Card.Body>
                  <h6 className="mb-3">{product.name}</h6>
                  <p style={{minHeight: "125px"}}>{product.description}</p>
                  <CustomButton
                    buttonType={2}
                    text="Order Now"
                    size="md"
                    path="onlineorder"
                    onClick={() => handleClick("onlineorder")}
                    require
                  /> 
                </Card.Body>
              </Card>
            </div>
            ))}
          </Carousel>

        </div>
      </div>

      <div className="container mt-5">
        <div className="standards row">
          <div className="col-xl-6 col-lg-6 col-md-12 order-2 order-md-1" data-aos="fade-right">
            <div className="heading">
              <p className="text-uppercase m-0">Our promises</p>

              <h1 className="mb-4">Redefining the Standards</h1>
            </div>

            <div className="row">
              <div className="col-xl-6 col-lg-6 col-md-6">
                <div className="box">
                  <img
                    className="mb-3"
                    src="images/customer-service.png"
                    alt="customer-service"
                  />
                  <h5 className="mb-3 fw-semibold">
                    100% Whole Wheat / Millets
                  </h5>
                  <p className="fw-semibold wheatbakes-para-justify">
                    Discover the magic of millet and the wholesome goodness of
                    wheat in every bite
                  </p>
                </div>
              </div>

              <div className="col-xl-6 col-lg-6 col-md-6">
                <div className="box">
                  <img
                    className="mb-3"
                    src="images/high-quality.png"
                    alt="high-quality"
                  />
                  <h5 className="mb-3 fw-semibold">100% Vegetarian</h5> <br />
                  <p className="fw-semibold wheatbakes-para-justify">
                    Our cakes are crafted with care, using only the finest
                    plant-based ingredients.
                  </p>
                </div>
              </div>

              <div className="col-xl-6 col-lg-6 col-md-6">
                <div className="box">
                  <img
                    className="mb-3"
                    src="images/community.png"
                    alt="community"
                  />
                  <h5 className="mb-3 fw-semibold">100% No Preservatives</h5>
                  <p className="fw-semibold wheatbakes-para-justify">
                    Freshly baked, preservative-free indulgence. Our cakes offer
                    a delightful taste experience without any artificial
                    additives.
                  </p>
                </div>
              </div>

              <div className="col-xl-6 col-lg-6 col-md-6">
                <div className="box">
                  <img
                    className="mb-3"
                    src="images/targeting.png"
                    alt="targeting"
                  />
                  <h5 className="mb-3 fw-semibold">100% No Colors</h5>
                  <p className="fw-semibold wheatbakes-para-justify">
                    Every bite is a delight, free from synthetic colors and
                    artificial Flavours
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-6 col-lg-6 col-md-12 order-1 order-md-2 image-padding" data-aos="fade-left">
            <img className="w-100" src="images/service-1.jpg" alt="service-1" />
          </div>
        </div>
      </div>

      <div className="container">
        <div className="uniqueness my-5">
          <div className="heading mb-4" data-aos="fade-up">
            <h2 className="text-center">
              We're Not Just Different, We're Better
            </h2>
          </div>

          <div className="row">
            <div className="col-xl-4 col-lg-4 col-md-4 p-2">
              <RightIngredientsList />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-4 p-2">
              <img className="w-100 image-shadow" src="images/use-ingredient.jpg" alt="" />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-4 p-2">
              <WeNeverUse />
            </div>
          </div>

          <div className="my-4 text-center" data-aos="fade-up">
            <button className="wheatbakes-btn" onClick={()=>handleClickButton("faq")}>READ FAQ</button>
            
          </div>
        </div>
      </div>

      <div className="bg-text-image-card ">
        <div className="container my-5">
          <div className="standards row">
            <div className="col-xl-6 col-lg-6 py-5 col-md-12 order-t-1  image-padding" data-aos="fade-right">
              <img className="w-100" src="images/Group 33.png" alt="bakery" />
            </div>
            <div className="col-xl-6 col-lg-6 py-5 col-md-12 order-t-2">
              <div className="heading" data-aos="fade-left">
                <p className="text-uppercase m-0">The “Wheat Bakes” Story</p>

                <h1 className="mb-4">Why We Exist?</h1>
              </div>

              <div className="content">
                <p className="fw-semibold wheatbakes-para-justify" data-aos="fade-left">
                  We at Wheat Bakes dedicated to revolutionize the way people
                  enjoy cakes and desserts. We offer natural and healthy version
                  of cakes. Our passion for wholesome ingredients drives us to
                  craft delicious baked goods using{" "}
                  <strong>
                    100% natural ingredients, pure chocolate, nuts and fruits
                  </strong>{" "}
                  without added preservatives, synthetic colors, artificial
                  flavors, palm oil or refined sugar. We use jaggery as our
                  natural sweeteners to our cakes. Every item we create is a
                  step toward promoting healthier lifestyles while maintaining
                  the rich flavors that people love. That satisfy the diverse
                  tastes of our customers
                </p>
              </div>

              <div className="my-5">
                <button className="wheatbakes-btn" onClick={()=>handleClickButton("about-us")}>READ MORE</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-5">
        <div className="standards row">
          <div className="col-xl-6 col-lg-6 col-md-12 order-1 order-md-2  image-padding">
            <img className="w-100 image-shadow" src="images/app-img.jpg" alt="team" data-aos="fade-right" />
          </div>

          <div className="col-xl-6 col-lg-6 col-md-12 order-2 order-md-1">
            <div className="heading" data-aos="fade-left">
              <p className="text-uppercase m-0">OUR TEAM</p>

              <h1>Small Is “POWERFUL”</h1>
            </div>

            <div className="content" data-aos="fade-left">
              <p className="fw-semibold wheatbakes-para-justify">
                Our team of skilled bakers brings years of experience to every
                product we create, ensuring excellence from start to finish.
              </p>

              <p className="fw-semibold wheatbakes-para-justify">
                At Wheat Bakes, we believe that great baking is about more than
                just great taste—it's about creating a memorable experience,
                building community, and contributing to a better future through
                sustainable and ethical practices
              </p>

              <p className="fw-semibold wheatbakes-para-justify">
                Let us bring the taste of tradition, healthy and innovation to
                your table.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container my-2">
        <div className="standards row align-items-center">
          <div className="col-xl-6 col-lg-6 col-md-12 order-t-2  image-padding" data-aos="fade-right">
            <img
              className="img-fluid"
              src="images/single-image.jpg"
              alt="partners"
            />
          </div>

          <div className="col-xl-6 col-lg-6 col-md-12 order-t-1" >
            <div className="heading" data-aos="fade-left">
              <p className="text-uppercase m-0">Our Collaborative Brands</p>

              <h1>Proudly Partnered With...</h1>
            </div>

            <div className="content" data-aos="fade-left">
              <p className="fw-semibold wheatbakes-para-justify">
                At Wheat Bakes, we're proud to feature a hand-picked selection
                of high-quality products from partners who share our commitment
                to natural goodness. Discover more delicious and wholesome
                options alongside our bakes.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      {/* <div className="bg-text-image-card p-5">
        <Container>
          <h2 className="text-align-center text-bold-600">
            Connect With Us On Instagram
          </h2>
          <div class="elfsight-app-87895633-540f-4cc8-a3a6-bd1a25a94234" data-elfsight-app-lazy></div>
        </Container>
      </div>
      
      <div className="p-4">
      <Container>
        <div className="elfsight-app-4144f679-3a52-4ca0-a80a-69ef1d8b4ecf" data-elfsight-app-lazy></div>
      </Container>
      </div> */}
      
    </div>
    </>
  );
};

export default Home;
